import { SelectChangeEvent, SxProps, Theme } from '@mui/material';
import { ComboStrikesChart, ExpandableContentWrapper } from 'components';
import { CanvasContentId } from 'types/canvas';
import { IndicesContentType } from 'types';
import { getDefaultSymOptions } from 'util/indices';
import { CanvasGroupLinkButton } from 'components/canvas/groups';

interface CanvasComboStrikesProps {
  id: number;
  sym: string;
  onSymChange: (sym: string) => void;
}

const CanvasComboStrikes = ({
  id,
  sym,
  onSymChange,
}: CanvasComboStrikesProps) => {
  const handleSymChange = (event: SelectChangeEvent<string>) => {
    const sym = event.target.value;
    onSymChange(sym ?? 'SPX');
  };

  const containerStyleOverrides: SxProps<Theme> = {
    height: '95%',
  };

  return (
    <ExpandableContentWrapper type={IndicesContentType.COMBO_STRIKES}>
      <ComboStrikesChart
        containerStyleOverrides={containerStyleOverrides}
        selectedSym={sym}
        symSelectorSettings={{
          value: sym,
          options: getDefaultSymOptions(IndicesContentType.COMBO_STRIKES),
          onChange: handleSymChange,
        }}
        headerExtras={
          <CanvasGroupLinkButton
            componentId={id}
            contentId={CanvasContentId.COMBO_STRIKES}
          />
        }
      />
    </ExpandableContentWrapper>
  );
};

export default CanvasComboStrikes;
